import React from "react";

import { connect } from "react-redux";
import { ENGLISH, ARABIC } from "../state/actions/localization.action";

const withLocalization = Component => {
  const mapStateToProps = state => ({
    i18n: state.localization
  });

  const mapDispatchToProp = dispatch => ({
    setEnglish: () => dispatch({ type: ENGLISH }),
    setArabic: () => dispatch({ type: ARABIC })
  });

  const WrappedComponent = props => (
    <Component {...props}>{props.children}</Component>
  );

  return connect(mapStateToProps, mapDispatchToProp)(WrappedComponent);
};

export default withLocalization;
